import React from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { addToPlaylist } from '../../actions';
import { playlistEpisodesLimit } from '../../lib/utils';
import { CheckOutlined, PlusOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import { PUBLIC } from '../../actions/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function AddPlaylistTile({ userPlaylistId, userPlaylist, podcastEpisode, addToPlaylist }) {
    function isInPlaylist() {
        if (userPlaylist['guidEpisodeArray']) {
            for (let guid of userPlaylist['guidEpisodeArray']) {
                let episodeGUID = podcastEpisode['guid'] || '';
                if (guid == episodeGUID) {
                    return true;
                }
            }
        }
        return false;
    }

    function addToPlaylistFn() {
        // const { userPlaylists } = this.props;

        /// *** if episode already belongs to that specific playlist, dont add again
        if (userPlaylist['guidEpisodeArray']) {
            let episodeGUID = podcastEpisode['guid'] || '';
            if (userPlaylist['guidEpisodeArray'].includes(episodeGUID)) {
                return;
            }

            //// check for playlist episode limit from guidArray size
            console.dir(userPlaylist['guidEpisodeArray'].length);
            if (userPlaylist['guidEpisodeArray'].length >= playlistEpisodesLimit) {
                notification['error']({
                    message: 'Cannot add to this playlist.',
                    description: `A playlist can't have more than ${playlistEpisodesLimit} episodes but 
                    you can create unlimited playlists, so that it's easier to sort playlists.`,
                    duration: null
                });
                return;
            }
        }

        console.log('proceed');
        addToPlaylist(podcastEpisode, userPlaylistId);
        return;
    }

    return (
        // <Menu.Item>
        // </Menu.Item>
        <a onClick={addToPlaylistFn}><p className='mb-0'>{isInPlaylist() ? <CheckOutlined style={{ color: 'green' }} /> : <PlusOutlined />} {userPlaylist.name} {userPlaylist.collaborative && <UsergroupAddOutlined />} {userPlaylist.type === 'public' && <FontAwesomeIcon icon='users' />}</p></a>
    );
}
AddPlaylistTile.propTypes = {
    userPlaylistId: PropTypes.string.isRequired,
    userPlaylist: PropTypes.object.isRequired,
    podcastEpisode: PropTypes.object.isRequired,
    addToPlaylist: PropTypes.func
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToPlaylist: bindActionCreators(addToPlaylist, dispatch),
    }
};

export default connect(null, mapDispatchToProps)(AddPlaylistTile)